<template>
  <BulkActionMenu :actions="actions">
    <template v-slot:delete="{ hide }">
      <Delete
        :module-name="type"
        :handle-delete-items="bulkDelete"
        @trigger="hide"
      />
    </template>
    <template v-slot:archive="{ hide }">
      <Archive
        :module-name="type"
        :handle-archive-items="bulkArchive"
        @trigger="hide"
      />
    </template>
    <template v-slot:restore="{ hide }">
      <Restore
        :module-name="type"
        :handle-restore-items="restoreItems"
        @trigger="hide"
      />
    </template>
  </BulkActionMenu>
</template>

<script>
import BulkActionMenu from '@components/bulk-action-menu'
import {
  restoreDiscoveryAgentsApi,
  deleteDiscoveryAgentsApi,
  deleteDiscoveryPollerConfigApi,
  deleteCredentialProfileApi,
  restoreCredentialProfileApi,
} from '../../api/discovery-agents-api'
import {
  deleteRdpAgentsApi,
  restoreRdpAgentsApi,
} from '../../api/rdp-configuration-api'
import Delete from './action-menu-items/delete'
import Archive from './action-menu-items/archive'
import Restore from './action-menu-items/restore'

export default {
  name: 'BulkActions',
  components: {
    BulkActionMenu,
    Delete,
    Archive,
    Restore,
  },
  props: {
    filter: { type: String, default: undefined },
    selectedItemIds: { type: Array, required: true },
    selectedItemFullDetails: { type: Array, required: true },
    toggleSelectAll: { type: Function, required: true },
    bulkDeleteFn: { type: Function, default: undefined },
    refreshList: { type: Function, required: true },
    type: { type: String, default: undefined },
  },
  data() {
    if (this.filter === 'archived') {
      this.actions = ['delete', 'restore']
    } else if (this.type === 'mobile_agents' || this.type === 'poller') {
      this.actions = ['delete']
    } else {
      this.actions = ['archive']
    }
    return {}
  },
  methods: {
    unselectAll() {
      this.toggleSelectAll()
    },
    bulkArchive() {
      if (this.type === 'rdp_agent') {
        return deleteRdpAgentsApi(this.selectedItemIds, false).then(
          (response) => {
            this.failedResponse(response)
          }
        )
      } else if (this.type === 'agent_credential_profile') {
        return deleteCredentialProfileApi(this.selectedItemIds, false).then(
          (response) => {
            this.failedResponse(response)
          }
        )
      }
      return deleteDiscoveryAgentsApi(this.selectedItemIds, false).then(
        (response) => {
          this.failedResponse(response)
        }
      )
    },
    bulkDelete() {
      if (this.type === 'rdp_agent') {
        return deleteRdpAgentsApi(this.selectedItemIds, true).then(
          (response) => {
            this.failedResponse(response)
          }
        )
      } else if (this.type === 'agent_credential_profile') {
        return deleteCredentialProfileApi(this.selectedItemIds, true).then(
          (response) => {
            this.failedResponse(response)
          }
        )
      }
      if (this.bulkDeleteFn) {
        return this.bulkDeleteFn(this.selectedItemIds).then(() => {
          this.refreshList()
        })
      }
      if (this.type === 'poller') {
        return deleteDiscoveryPollerConfigApi(this.selectedItemIds).then(() => {
          this.refreshList()
        })
      } else {
        return deleteDiscoveryAgentsApi(this.selectedItemIds, true).then(
          (response) => {
            this.failedResponse(response)
          }
        )
      }
    },
    restoreItems() {
      if (this.type === 'rdp_agent') {
        return restoreRdpAgentsApi(this.selectedItemIds).then((response) => {
          this.failedResponse(response)
        })
      } else if (this.type === 'agent_credential_profile') {
        return restoreCredentialProfileApi(this.selectedItemIds, true).then(
          (response) => {
            this.failedResponse(response)
          }
        )
      }
      return restoreDiscoveryAgentsApi(this.selectedItemIds).then(
        (response) => {
          this.failedResponse(response)
        }
      )
    },
    handleFailedResponse(failed) {
      const items = failed
        .map((f) => {
          const i = this.selectedItemFullDetails.find((x) => x.id === f.id)
          if (i) {
            return {
              ...f,
              subject: i.displayName,
              name: i.name,
            }
          }
          return undefined
        })
        .filter(Boolean)
      this.$emit('bulk-update-error', items)
    },
    failedResponse(response) {
      if (response.failed.length) {
        this.handleFailedResponse(response.failed)
      }
      return this.refreshList()
    },
  },
}
</script>
